import { useState } from "react";
import Button from "./Buttons/Button";
import Modal from "./Modal";
import styled from "styled-components";
import { ReactComponent as BalloonIcon } from "../assets/balloon.svg";

interface InspectionFormNoteModalProps {
  note: string;
  onSave: (note: string) => void;
  title: string;
  subtitle: string;
  submitLabel: string;
  show: boolean;
  onCancel: () => void;
  maxLength?: number;
}

const InspectionFormNoteModal = ({
  note,
  onSave,
  title,
  subtitle,
  submitLabel,
  onCancel,
  show,
  maxLength,
}: InspectionFormNoteModalProps) => {
  const [currentNote, setCurrentNote] = useState<string>(note || "");

  return (
    <Modal show={show} onDismiss={onCancel}>
      <NoteContainer>
        <NoteHeader>
          <IconContainer>
            <BalloonIcon />
          </IconContainer>
          <h2>{title}</h2>
        </NoteHeader>
        <TextAreaContainer>
          <Subtitle>{subtitle}</Subtitle>
          <Textarea
            maxLength={maxLength}
            onChange={(e) => setCurrentNote(e.target.value)}
            defaultValue={note}
            autoFocus={true}
          />
        </TextAreaContainer>
        <Button
          onClick={() => {
            onSave(currentNote);
            onCancel();
          }}
          color="green"
          size="medium"
          label={submitLabel}
        />
      </NoteContainer>
    </Modal>
  );
};

export default InspectionFormNoteModal;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30px;
  background-color: #0075bc;
  border-radius: 5px;
  margin-right: 12px;
  svg {
    height: 15px;
    width: 15px;
    fill: white;
  }
`;

const NoteContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  textarea {
    height: 154px;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
  }
  button {
    width: 200px;
  }
`;

const NoteHeader = styled.div`
  display: flex;
  align-items: center;
  h2 {
    color: #0075bc;
  }
`;

const Subtitle = styled.span`
  font-weight: 700;
  text-align: left;
`;

const TextAreaContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Textarea = styled.textarea`
  padding: 12px;
  margin-top: 12px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;

  /* or 19px */
  display: flex;
  align-items: center;

  /* Donkergrijs */
  color: #212529;

  background: #ffffff;

  /* Dropshadow */
  box-shadow: 0px 10px 15px rgba(168, 168, 168, 0.2);
  border-radius: 5px;
  border: 0;
`;
